var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('ld-persistent-banner',{attrs:{"error":true,"text":_vm.text,"buttonText":_vm.buttonText,"loading":_vm.isSending,"complete":_vm.isComplete},on:{"input":_vm.onResend}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }